<template lang="pug">
.cardContainer(:style="`flex:0 0 ${ width }`")
  .customCard(:style="`height: ${ height };`" :class='{cardLightBackground: !background, cardDarkBackground: background}')
    .container(:class="{vertical: !horizontal, alignTextLeft: itemLeft && !horizontal}")
      .title.sweet-gothic(:class='{lightText: background, darkText: !background, marginRight: horizontal}') {{ title }}
      .text(:class='amountStyles' v-if="isText && !isPercent") {{ text }}
      .amount(:class='amountStyles' v-if="!isPercent && !cash && !isText && !isDate && !isYear") {{ amount }}
      .amount(:class='amountStyles' v-if="cash && !isText") {{ amount | currency }} {{ currency }}
      .percent(:class='amountStyles' v-if="isPercent && isText") {{ text }}%
      .date(:class='amountStyles' v-if="isDate") {{ text | moment("DD MMMM YYYY") }}
      .year(:class='amountStyles' v-if="isYear") {{ text | moment("YYYY") }}
</template>

<script>
export default {
  name: 'Card',
  components: {},
  props: {
    title: {
      default: 'Sample Card Text',
      type: String
    },
    amount: {
      default: 0,
      type: Number
    },
    cash: {
      default: false,
      type: Boolean
    },
    currency: {
      default: '',
      type: String
    },
    background: {
      default: false,
      type: Boolean
    },
    center: {
      default: 'left',
      type: String
    },
    horizontal: {
      default: false,
      type: Boolean
    },
    italic: {
      default: true,
      type: Boolean
    },
    itemLeft: {
      default: true,
      type: Boolean
    },
    width: {
      default: '33.333333%',
      type: String
    },
    height: {
      default: '100px',
      type: String
    },
    isText: {
      default: false,
      type: Boolean
    },
    text: {
      default: '',
      type: String
    },
    blackText: {
      default: false,
      type: Boolean
    },
    isDate: {
      default: false,
      type: Boolean
    },
    isYear: {
      default: false,
      type: Boolean
    },
    isPercent: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    amountStyles () {
      return {
        secondLightText: this.background,
        secondDarkText: !this.background,
        'gandhi-serif-bold-italic': this.italic,
        'gandhi-serif-regular': !this.italic,
        black: this.blackText
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cardContainer {
  box-sizing: content-box;
  .customCard {
    user-select: none;
    position: relative;
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    margin: 15px 15px 10px;
    background: white;
    padding: 5px;
    border-radius: 15px;
    .container {
      padding: 15px 25px;
      display: flex;
      justify-items: center;
      align-items: left;
      height: 100%;
      text-align: left;
      .title {
        font-weight: bold;
        font-size: 16px;
      }
      .percent {
        font-weight: bold;
        font-size: 2rem;
      }
      .amount {
        font-weight: bold;
        font-size: 2.3vw;
      }
      .alignTextLeft {
        text-align: left;
        align-items: start;
      }
      .text {
        font-weight: bold;
        font-size: 2.3vw;
      }
      .date,
      .year {
        font-weight: bold;
        font-size: 1.9rem;
      }
    }
    .form {
      .con-select {
        width: 100%;
      }
    }
    .vm-con-table {
      width: 100%;
    }
  }
}
.vertical {
  flex-direction: column;
}
.marginRight {
  margin-right: 1rem;
}
.black {
  color: black;
}
</style>
